import {CtModelRouteData} from "@ctsolution/ct-framework";

export const WorkOrderCustomTemplateRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("WorkOrderCustomTemplate");
